/* eslint-disable no-mixed-spaces-and-tabs */
import { datetimeCovertertolocal } from '../../datetime-converter';
import { SCHEDULE_LIST, SCHEDULE_LIST_ERROR, SCHEDULE_LIST_SUCCESS, USERS_LIST, USERS_LIST_ERROR, USERS_LIST_SUCCESS } from './constants';

export default function shiftdata(state, action) {

	let schedule = [];
	let pagination = {};

	switch (action.type) {
      
	case SCHEDULE_LIST:
		return { ...state, pending: true };
    
	case SCHEDULE_LIST_SUCCESS:
            
		if (action.payload) {
			pagination.total = action.payload.total ? action.payload.total : 0;
			pagination.limit = action.payload.limit ? action.payload.limit : 10;
			pagination.skip = action.payload.skip ? action.payload.skip : 0;
			pagination.current = action.page ? action.page : 1;
			pagination.pageSize =  action.pageSize ? action.pageSize : 10;
		}
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.forEach((item) => {
                    
				const fromTime = datetimeCovertertolocal(item ? item.datetimeFrom : '<Not Set>');
				const newFromTime = item && item.datetimeFrom ? (fromTime.localdate + ' ' + fromTime.localtime) : '<Not Set>';
				const toTime = datetimeCovertertolocal(item ? item.datetimeTo : '<Not Set>');
				const newToTime = item && item.datetimeTo ? (toTime.localdate + ' ' + toTime.localtime) : '<Not Set>';
    
				schedule.push({
					id : item.id,
					name : item.name ? item.name : 'No Data',
					datetimeFrom : newFromTime,
					datetimeTo : newToTime,
					latestSchedule : item.latestSchedule,
					utcTimeTo : item.datetimeTo,
					utcTimeFrom : item.datetimeFrom,
					userName :item?.users?  item?.users?.firstName + ' ' + item?.users?.lastName : 'No Data'
				});
			});
                
		}
		return { ...state, pending : false, error : false, schedule : schedule, pagination: pagination };
    
	case SCHEDULE_LIST_ERROR:
		return { ...state, error: false, pending: false };

	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };

      
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}